import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Select, Store} from '@ngxs/store';
import {Router} from '@angular/router';
import {NavService} from '../../../../services/nav.service';
import {DocumentState} from '../../../../state/document/document.state';
import {SearchList} from '../../../../models/search-list.model';
import {Document} from '../../../../models/document.model';
import {DatatableColumn} from '../../components/datatable/models/datatable-column.model';
import {ModalService} from '../../../../services/modal.service';
import {TranslateService} from '@ngx-translate/core';
import {SearchQueryParams} from '../../../../models/search-query-params.model';
import {NavItemCodes} from '../../../../enums/nav-item-codes.enum';
import {DocumentActions} from '../../../../state/document/document.actions';
import {FileService} from '../../../../services/file.service';

@Component({
    selector: 'app-document-list',
    templateUrl: './document-list.component.html'
})
export class DocumentListComponent implements OnInit, OnDestroy {
    @Select(DocumentState.documentList) documentList$: Observable<SearchList<Document>>;
    public navItemCodes = NavItemCodes;
    public editMode = false;
    public code = NavItemCodes.DOCUMENT_MANAGEMENT;

    public headerNavItems = [];

    public tableColumns: DatatableColumn[] = [
        {name: 'LABELS.CATEGORY', key: 'category'},
        {name: 'LABELS.NAME', key: 'documentName'},
        {name: 'LABELS.SIGNATURE', key: 'signatureOwu'},
        {name: 'LABELS.CREATED_AT', align: 'center'},
        {name: 'LABELS.OPERATIONS'},
    ];

    subscriptions: Subscription = new Subscription();

    documentList: SearchList<Document> = null;


    constructor(
        router: Router,
        private store: Store,
        private modalService: ModalService,
        private translateService: TranslateService,
        private fileService: FileService
    ) {
        this.editMode = router.url === NavService.get(NavItemCodes.DOCUMENT_MANAGEMENT).path;
        if (this.editMode) {
            this.handleEditMode();
        }
    }

    ngOnInit() {
        this.subscriptions.add(
            this.documentList$.subscribe(list => {
                this.documentList = list;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    queryParamsChange(params: SearchQueryParams) {
        this.store.dispatch(new DocumentActions.GetListPage(params));
    }

    deleteDocument(item: Document) {
        this.modalService.confirm({
            nzContent: this.translateService.instant('DOCUMENT.DELETE_CONFIRMATION', {name: item.documentName}),
            nzOnOk: () => {
                this.store.dispatch(new DocumentActions.Delete(item));
            }
        });
    }

    downloadDocument(item: Document) {
        if (item?.file?.hash) {
            this.fileService.getTokenByHash(item?.file?.hash);
        }
    }

    handleEditMode() {
        this.code = NavItemCodes.DOCUMENT_MANAGEMENT;
        this.tableColumns = [
            {name: 'LABELS.CATEGORY', key: 'category'},
            {name: 'LABELS.NAME', key: 'documentName'},
            {name: 'LABELS.SIGNATURE', key: 'signatureOwu'},
            {name: 'DOCUMENT.KID_ASSIGNED', key: 'indicationOnKid'},
            {name: 'LABELS.PARTNERS', align: 'center'},
            {name: 'LABELS.VISIBILITY', key: 'visibility', align: 'center'},
            {name: 'LABELS.ATTACHMENT', key: 'policyAttachment', align: 'center'},
            {name: 'LABELS.CREATED_AT', key: 'createdAt', align: 'center'},
            {name: 'LABELS.OPERATIONS'},
        ];
        this.headerNavItems.push(NavService.get(NavItemCodes.DOCUMENT_ADD));
    }
}
